import { render } from "./MorePages.vue?vue&type=template&id=045cbbc6&scoped=true"
import script from "./MorePages.vue?vue&type=script&lang=js"
export * from "./MorePages.vue?vue&type=script&lang=js"

import "./MorePages.vue?vue&type=style&index=0&id=045cbbc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045cbbc6"]])

export default __exports__